
export const theme = {
  colors: {
    primary: '#183860',
    primaryDark: '#0E233E',
    primaryLight: '#265084',
    accent: '#E5202A',
    accentHover: '#C81922',
    textMain: '#182230',
    textMid: '#334155',
    textLight: '#4B596B',
    bgWhite: '#FAFBFD',
    bgLight: '#EEF2F6',
    border: '#CBD5E1'
  },
  esiti: {
    OK: { label: 'OK', color: 'var(--wfm-success-text)', bg: 'var(--wfm-success-bg)' },
    KO: { label: 'KO', color: 'var(--wfm-error-text)', bg: 'var(--wfm-error-bg)' },
    NON_LAVORABILE: { label: 'Non Lavorabile', color: 'var(--wfm-warning-text)', bg: 'var(--wfm-warning-bg)' },
    ALTRO: { label: 'Altro', color: 'var(--wfm-neutral-text)', bg: 'var(--wfm-neutral-bg)' }
  },
  chartColors: ['#22C55E', '#EF4444', '#F97316', '#6B7280'],
  roleLabels: {
    SUPER_ADMIN: 'Super Admin',
    MANAGER: 'Manager',
    ADMIN: 'Admin',
    OPERATOR: 'Operatore'
  },
  roleBadgeColors: {
    SUPER_ADMIN: { bg: 'var(--wfm-error-bg)', text: 'var(--wfm-error-text)', border: 'var(--wfm-error-border)' },
    MANAGER: { bg: 'var(--wfm-purple-bg)', text: 'var(--wfm-purple-text)', border: 'var(--wfm-purple-border)' },
    ADMIN: { bg: 'var(--wfm-info-bg)', text: 'var(--wfm-info-text)', border: 'var(--wfm-info-border)' },
    OPERATOR: { bg: 'var(--wfm-success-bg)', text: 'var(--wfm-success-text)', border: 'var(--wfm-success-border)' }
  }
};
